import { createVNode, mergeProps } from "vue";
export default {
  name: 'GiftIcon',
  props: {
    size: {
      type: String,
      default: '16',
      validator: s => !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x'
    }
  },

  setup(props, ctx) {
    const size = props.size.slice(-1) === 'x' ? props.size.slice(0, props.size.length - 1) + 'em' : parseInt(props.size) + 'px';
    const attrs = { ...ctx.attrs
    };
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    return () => createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "class": "feather feather-gift"
    }, { ...attrs
    }), [createVNode("polyline", {
      "points": "20 12 20 22 4 22 4 12"
    }), createVNode("rect", {
      "x": "2",
      "y": "7",
      "width": "20",
      "height": "5"
    }), createVNode("line", {
      "x1": "12",
      "y1": "22",
      "x2": "12",
      "y2": "7"
    }), createVNode("path", {
      "d": "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
    }), createVNode("path", {
      "d": "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
    })]);
  }

};